import { Box, Flex } from '@chakra-ui/react';

export function Step({ steps, currentStep }: { steps: string[]; currentStep: number }) {
  return (
    <Flex w="100%">
      {steps.map((step, index) => (
        <Flex flexDirection="column" gap="12px" key={index} w="100%">
          <Flex alignItems="center" w="100%">
            <Box
              w="10px"
              h="10px"
              borderRadius="50%"
              bg={index <= currentStep ? 'primary.900' : 'neutrals.500'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="xs"
              fontWeight="bold"
            />
            {index < steps.length - 1 && (
              <Box
                flex="1"
                h="2px"
                bg={index < currentStep ? 'primary.900' : 'neutrals.100'}
                mx="4px"
              />
            )}
          </Flex>
          <Box fontSize="14px" color={index <= currentStep ? 'neutrals.900' : 'neutrals.500'}>
            {step}
          </Box>
        </Flex>
      ))}
    </Flex>
  );
}
